import { useState, useCallback } from 'react';
import axios from 'axios';
import { getToken } from '../../services/authToken';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function useSpinWheel() {
  const [status, setStatus] = useState(null); // null | { already_used, next_spin_at }
  const [loading, setLoading] = useState(false);
  const [spinning, setSpinning] = useState(false);
  const [reward, setReward] = useState(null);
  const [error, setError] = useState(null);

  const fetchToday = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const token = getToken();
      const res = await axios.get(`${API}/cabin/spin-wheel/today`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setStatus(res.data);
    } catch (err) {
      setError(err?.response?.data?.message_tr || err.message);
    } finally {
      setLoading(false);
    }
  }, []);

  const spin = useCallback(async () => {
    setSpinning(true);
    setError(null);
    try {
      const token = getToken();
      const res = await axios.post(
        `${API}/cabin/spin-wheel/spin`,
        {},
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setReward(res.data?.reward || res.data);
      setStatus((prev) => ({ ...prev, already_used: true }));
      return res.data?.reward || res.data;
    } catch (err) {
      setError(err?.response?.data?.message_tr || err.message);
      return null;
    } finally {
      setSpinning(false);
    }
  }, []);

  return { status, loading, spinning, reward, error, fetchToday, spin };
}
